<div class="mt-auto p-6 pt-0 text-center dark:text-white-dark">© {{ currYear }}. Infraseg. Todos os direitos reservados.</div>
